import { Box } from '@chakra-ui/react';
import styled from '@emotion/styled';

export const WrapSimpleGrid = styled(Box)``;
